module.exports = "<div class=\"col-md-12\">\n    <div class=\"row\">\n      <div class=\"col-md-2 group-shell-nav-tabs\" *ngIf=\"!inTeamDeeperLevel\">\n          <app-router-tabs [routeInfo]=\"links\"></app-router-tabs>\n      </div>\n      <div class=\"col-md-10 users\">\n        <router-outlet></router-outlet>\n      </div>\n    </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/dashboard/program-list/program/groups/group-shell/group-shell.component.html
// module id = ../../../../../src/app/dashboard/program-list/program/groups/group-shell/group-shell.component.html
// module chunks = 2